export var IteratorResultSlots;
(function (IteratorResultSlots) {
    IteratorResultSlots[IteratorResultSlots["done"] = 0] = "done";
    IteratorResultSlots[IteratorResultSlots["value"] = 1] = "value";
})(IteratorResultSlots || (IteratorResultSlots = {}));
export var IterableIteratorSlots;
(function (IterableIteratorSlots) {
    IterableIteratorSlots[IterableIteratorSlots["next"] = 0] = "next";
    IterableIteratorSlots[IterableIteratorSlots["iterator"] = 1] = "iterator";
    IterableIteratorSlots[IterableIteratorSlots["internalIterator"] = 2] = "internalIterator";
})(IterableIteratorSlots || (IterableIteratorSlots = {}));
export var ErrorSlots;
(function (ErrorSlots) {
    ErrorSlots[ErrorSlots["message"] = 0] = "message";
})(ErrorSlots || (ErrorSlots = {}));
export var StructuredStorageSlots;
(function (StructuredStorageSlots) {
    StructuredStorageSlots[StructuredStorageSlots["prefix"] = 0] = "prefix";
    StructuredStorageSlots[StructuredStorageSlots["size"] = 1] = "size";
    StructuredStorageSlots[StructuredStorageSlots["prefixArray"] = 2] = "prefixArray";
})(StructuredStorageSlots || (StructuredStorageSlots = {}));

//# sourceMappingURL=Slots.js.map
